import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useLang from "../../hooks/useLang";

const LanguageSelector = ({ className }) => {
  const { i18n, t } = useTranslation();
  const getLang = useLang().getLang();
  const setLang = useLang();
  const lang = typeof getLang === "string" ? getLang.toUpperCase() : "TR";

  const [curLang, setCurLang] = useState(lang);

  const changeLanguage = () => {
    const language = curLang === "TR" ? "EN" : "TR";
    setCurLang(language);
    i18n.changeLanguage(language.toLowerCase());
    setLang.setLang(language.toLowerCase());
  };

  return (
    <div>
      <button
        type="button"
        onClick={changeLanguage}
        aria-label={`${t("common.language")} (${curLang})`}
        title={t("common.language")}
        className={`w-[3.3rem] h-7 flex items-center rounded-full p-1 cursor-pointer transition-colors duration-300 border border-[--tx-3] border-solid bg-transparent ${className}`}
      >
        <span
          className={`bg-white text-black w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 flex items-center justify-center text-sm ${
            curLang === "TR" ? "translate-x-6" : ""
          }`}
        >
          {curLang}
        </span>
      </button>
    </div>
  );
};

export default LanguageSelector;
